// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.quizz {
  max-width: 50rem;
}

.quizz__header {
  padding-bottom: 1.5em;
  border-bottom: 0.1rem solid var(--clr-gray500);
}

.quizz__header h1 {
  font-size: 3.4rem;
}

.quizz__header p {
  margin-top: 1rem;
  line-height: 1.8;
}
/* 
.quizz__content {
 
  padding: 1em 0;
  margin: -1rem 0;
} */

.quizz__content .loading-container-text {
  margin-top: 3rem;
}

.quizz__results {
  display: grid;
  gap: 1.5rem;
  overflow-x: scroll;
  padding: 1em;
  margin: -1em;
  scrollbar-width: none;
  grid-template-columns: repeat(auto-fill, minmax(25rem, 1fr));
  /* grid-template-rows: 1fr; */
  grid-auto-flow: column;
}

.quizz__resultsContainer {
  position: relative;
}

.quizz__resultsContainer::before,
.quizz__resultsContainer::after {
  content: "";
  position: absolute;
  height: 100%;
  width: 5rem;
  top: 50%;
  transform: translateY(-50%);
  z-index: 4;
  pointer-events: none;
}

.quizz__resultsContainer.max-left-side::before {
  right: -1rem;
  pointer-events: all;
  background: linear-gradient(270deg, #fcfbf9 0%, rgba(247, 247, 252, 0) 100%);
}

.quizz__resultsContainer.max-right-side::after {
  pointer-events: all;
  left: -1rem;
  background: linear-gradient(-270deg, #fcfbf9 0%, rgba(247, 247, 252, 0) 100%);
}

.quizz__chevron {
  position: absolute;
  width: 3rem;
  top: 50%;
  cursor: pointer;
  z-index: 6;
  transform: translateY(-50%);
}

.quizz__chevron.right {
  right: -0.5rem;
}
.quizz__chevron.left {
  left: -0.5rem;
}

.quizz__results::-webkit-scrollbar {
  display: none;
}

.quizz__cardContainer {
  display: grid;
  gap: 1.5rem;
  grid-template-columns: repeat(auto-fit, minmax(15rem, 1fr));
}

.quizz__quizzTitle {
  display: flex;
  align-items: center;
  /* font-size: 2.2rem; */
  font-size: 1.2rem;

  margin: 1.5rem 0;
}

.quizz__number {
  display: grid;
  place-items: center;
  aspect-ratio: 1 / 1;
  /* height: 3rem;
  width: 3rem; */
  height: 2rem;
  width: 2rem;
  margin-right: 1rem;
  color: var(--clr-light);
  border-radius: 50%;
  background: var(--clr-primary-dark);
}

.quizz__nav {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 1rem;
  justify-content: center;
  background: var(--clr-gray300);
  border-radius: 1.25em;
  padding: 1em 1.25em;
  margin: 5rem 0 2rem 0;
  border: 0.1rem solid var(--clr-gray);
  box-shadow: 0px 0.75rem 1rem rgba(63, 14, 14, 0.05);
}

.quizz__nav > div {
  display: flex;
  flex: 1 1 33%;
  align-items: center;
}
.quizz__nav.end-nav > div {
  flex: none;
}

.quizz__nav > div span {
  white-space: nowrap;
}
.quizz__nav svg {
  width: 1.5rem;
  margin-right: 0.5rem;
}

.quizz__navBtnContainer {
  justify-content: flex-end;
  /* max-width: 14rem; */
}

.quizz__navBtnContainer button {
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 1em;
  padding: 0.75em 1.25em;
  border: 0.1rem solid var(--clr-primary);
}
.quizz__navBtnContainer button:last-of-type svg,
.quizz__navBtnContainer button:last-of-type {
  margin-left: 0.5rem;
}
.quizz__navBtnContainer button:last-of-type {
  width: 100%;
}
.quizz__navBtnContainer svg {
  width: 1.25rem;
  margin-right: 0;
}

@media (min-width: 475px) {
  .quizz__resultsContainer::before,
  .quizz__resultsContainer::after {
    width: 8rem;
  }

  .quizz__chevron {
    width: 5.33rem;
  }
}

@media (min-width: 768px) {
  .quizz__cardContainer {
    grid-template-columns: repeat(auto-fit, minmax(20rem, 1fr));
  }

  .quizz__quizzTitle {
    font-size: 2.2rem;
  }

  .quizz__number {
    height: 3rem;
    width: 3rem;
  }

  .quizz__nav {
    flex-wrap: nowrap;
  }

  .quizz__navBtnContainer {
    max-width: 14rem;
  }

  .quizz__navBtnContainer button {
    padding: 1em 1.5em;
  }
}
`, "",{"version":3,"sources":["webpack://./src/pages/Quizz/Quizz.css"],"names":[],"mappings":"AAAA;EACE,gBAAgB;AAClB;;AAEA;EACE,qBAAqB;EACrB,8CAA8C;AAChD;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;AAClB;AACA;;;;;GAKG;;AAEH;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,WAAW;EACX,kBAAkB;EAClB,YAAY;EACZ,YAAY;EACZ,qBAAqB;EACrB,4DAA4D;EAC5D,6BAA6B;EAC7B,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;;EAEE,WAAW;EACX,kBAAkB;EAClB,YAAY;EACZ,WAAW;EACX,QAAQ;EACR,2BAA2B;EAC3B,UAAU;EACV,oBAAoB;AACtB;;AAEA;EACE,YAAY;EACZ,mBAAmB;EACnB,4EAA4E;AAC9E;;AAEA;EACE,mBAAmB;EACnB,WAAW;EACX,6EAA6E;AAC/E;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,QAAQ;EACR,eAAe;EACf,UAAU;EACV,2BAA2B;AAC7B;;AAEA;EACE,cAAc;AAChB;AACA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;EACb,WAAW;EACX,2DAA2D;AAC7D;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,iBAAiB;;EAEjB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB;gBACc;EACd,YAAY;EACZ,WAAW;EACX,kBAAkB;EAClB,uBAAuB;EACvB,kBAAkB;EAClB,mCAAmC;AACrC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,SAAS;EACT,uBAAuB;EACvB,8BAA8B;EAC9B,qBAAqB;EACrB,mBAAmB;EACnB,qBAAqB;EACrB,oCAAoC;EACpC,mDAAmD;AACrD;;AAEA;EACE,aAAa;EACb,aAAa;EACb,mBAAmB;AACrB;AACA;EACE,UAAU;AACZ;;AAEA;EACE,mBAAmB;AACrB;AACA;EACE,aAAa;EACb,oBAAoB;AACtB;;AAEA;EACE,yBAAyB;EACzB,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,sBAAsB;EACtB,uCAAuC;AACzC;AACA;;EAEE,mBAAmB;AACrB;AACA;EACE,WAAW;AACb;AACA;EACE,cAAc;EACd,eAAe;AACjB;;AAEA;EACE;;IAEE,WAAW;EACb;;EAEA;IACE,cAAc;EAChB;AACF;;AAEA;EACE;IACE,2DAA2D;EAC7D;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,YAAY;IACZ,WAAW;EACb;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,kBAAkB;EACpB;AACF","sourcesContent":[".quizz {\n  max-width: 50rem;\n}\n\n.quizz__header {\n  padding-bottom: 1.5em;\n  border-bottom: 0.1rem solid var(--clr-gray500);\n}\n\n.quizz__header h1 {\n  font-size: 3.4rem;\n}\n\n.quizz__header p {\n  margin-top: 1rem;\n  line-height: 1.8;\n}\n/* \n.quizz__content {\n \n  padding: 1em 0;\n  margin: -1rem 0;\n} */\n\n.quizz__content .loading-container-text {\n  margin-top: 3rem;\n}\n\n.quizz__results {\n  display: grid;\n  gap: 1.5rem;\n  overflow-x: scroll;\n  padding: 1em;\n  margin: -1em;\n  scrollbar-width: none;\n  grid-template-columns: repeat(auto-fill, minmax(25rem, 1fr));\n  /* grid-template-rows: 1fr; */\n  grid-auto-flow: column;\n}\n\n.quizz__resultsContainer {\n  position: relative;\n}\n\n.quizz__resultsContainer::before,\n.quizz__resultsContainer::after {\n  content: \"\";\n  position: absolute;\n  height: 100%;\n  width: 5rem;\n  top: 50%;\n  transform: translateY(-50%);\n  z-index: 4;\n  pointer-events: none;\n}\n\n.quizz__resultsContainer.max-left-side::before {\n  right: -1rem;\n  pointer-events: all;\n  background: linear-gradient(270deg, #fcfbf9 0%, rgba(247, 247, 252, 0) 100%);\n}\n\n.quizz__resultsContainer.max-right-side::after {\n  pointer-events: all;\n  left: -1rem;\n  background: linear-gradient(-270deg, #fcfbf9 0%, rgba(247, 247, 252, 0) 100%);\n}\n\n.quizz__chevron {\n  position: absolute;\n  width: 3rem;\n  top: 50%;\n  cursor: pointer;\n  z-index: 6;\n  transform: translateY(-50%);\n}\n\n.quizz__chevron.right {\n  right: -0.5rem;\n}\n.quizz__chevron.left {\n  left: -0.5rem;\n}\n\n.quizz__results::-webkit-scrollbar {\n  display: none;\n}\n\n.quizz__cardContainer {\n  display: grid;\n  gap: 1.5rem;\n  grid-template-columns: repeat(auto-fit, minmax(15rem, 1fr));\n}\n\n.quizz__quizzTitle {\n  display: flex;\n  align-items: center;\n  /* font-size: 2.2rem; */\n  font-size: 1.2rem;\n\n  margin: 1.5rem 0;\n}\n\n.quizz__number {\n  display: grid;\n  place-items: center;\n  aspect-ratio: 1 / 1;\n  /* height: 3rem;\n  width: 3rem; */\n  height: 2rem;\n  width: 2rem;\n  margin-right: 1rem;\n  color: var(--clr-light);\n  border-radius: 50%;\n  background: var(--clr-primary-dark);\n}\n\n.quizz__nav {\n  display: flex;\n  align-items: center;\n  flex-wrap: wrap;\n  gap: 1rem;\n  justify-content: center;\n  background: var(--clr-gray300);\n  border-radius: 1.25em;\n  padding: 1em 1.25em;\n  margin: 5rem 0 2rem 0;\n  border: 0.1rem solid var(--clr-gray);\n  box-shadow: 0px 0.75rem 1rem rgba(63, 14, 14, 0.05);\n}\n\n.quizz__nav > div {\n  display: flex;\n  flex: 1 1 33%;\n  align-items: center;\n}\n.quizz__nav.end-nav > div {\n  flex: none;\n}\n\n.quizz__nav > div span {\n  white-space: nowrap;\n}\n.quizz__nav svg {\n  width: 1.5rem;\n  margin-right: 0.5rem;\n}\n\n.quizz__navBtnContainer {\n  justify-content: flex-end;\n  /* max-width: 14rem; */\n}\n\n.quizz__navBtnContainer button {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  border-radius: 1em;\n  padding: 0.75em 1.25em;\n  border: 0.1rem solid var(--clr-primary);\n}\n.quizz__navBtnContainer button:last-of-type svg,\n.quizz__navBtnContainer button:last-of-type {\n  margin-left: 0.5rem;\n}\n.quizz__navBtnContainer button:last-of-type {\n  width: 100%;\n}\n.quizz__navBtnContainer svg {\n  width: 1.25rem;\n  margin-right: 0;\n}\n\n@media (min-width: 475px) {\n  .quizz__resultsContainer::before,\n  .quizz__resultsContainer::after {\n    width: 8rem;\n  }\n\n  .quizz__chevron {\n    width: 5.33rem;\n  }\n}\n\n@media (min-width: 768px) {\n  .quizz__cardContainer {\n    grid-template-columns: repeat(auto-fit, minmax(20rem, 1fr));\n  }\n\n  .quizz__quizzTitle {\n    font-size: 2.2rem;\n  }\n\n  .quizz__number {\n    height: 3rem;\n    width: 3rem;\n  }\n\n  .quizz__nav {\n    flex-wrap: nowrap;\n  }\n\n  .quizz__navBtnContainer {\n    max-width: 14rem;\n  }\n\n  .quizz__navBtnContainer button {\n    padding: 1em 1.5em;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
